import api from 'api';
import {DialogResult, DialogTypes} from 'common/names';
import {pageSelectors} from 'features/layout/CommonPage/redux';
import {PendingChangesDialogData} from 'features/layout/DialogRoutes/dialogs/PendingChangesDialog';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import i18n from 'i18n';
import {call, select, SagaReturnType} from 'redux-saga/effects';
import {backupTypes} from 'redux/backuprestore';
import {asyncSagaConstructor, unhandedSagaError} from 'redux/common';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {getBackupFilePath} from '../getBackupFilePath';
import qs from 'query-string';
import {getPassword} from 'redux/common/saga/getPassword';
import {DiplomatFeature} from 'types/DiplomatFeature';
import {licenseSelectors} from 'redux/license';
import {openRestoreDialog} from './openRestoreDialog';
import {ConfirmDialogData} from 'components/dialogs/ConfirmDialog';

export function* restoreSaga() {
   try {
      //if there are changes pending, find out if they want to continue
      //and lose the changes or quit
      const isPendingChanges = (yield select(pageSelectors.isPendingChanges)) as ReturnType<
         typeof pageSelectors.isPendingChanges
      >;
      if (isPendingChanges) {
         const result: ICloseSubDialogAction<boolean> = yield call(openDialogWithResult, {
            id: DialogTypes.PendingChangesDialog.id,
            data: {
               processLabel: i18n.t('restore'),
               confirmLabel: i18n.t('Restore'),
            } as PendingChangesDialogData,
         });
         if (result.payload?.data) {
            //lose changes
            //   yield put(action(pageTypes.RESET_ALL_FORMS));
         } else {
            //quit
            return;
         }
      }

      const dialogResult: ICloseSubDialogAction<boolean> = yield call(openDialogWithResult, {
         id: DialogTypes.ConfirmationDialog.id,
         title: i18n.t('Transaction Datastore Restore'),
         content: i18n.t(
            'The Restore function will overwrite your current Transaction Datastore.\n\nBefore the Transaction Datastore can be restored all job scheduling\nwill be suspended and processing will wait for all currently executing\njobs to finish running.\n\nDo you want to continue?'
         ),
      });

      if (dialogResult.payload?.result === DialogResult.OK) {
         yield call(restoreProccess);
      }
   } catch (e) {
      yield call(unhandedSagaError, e as Error);
   }
}

function* restoreProccess() {
   const isFeatureSupported = (yield select(licenseSelectors.isFeatureSupported)) as ReturnType<
      typeof licenseSelectors.isFeatureSupported
   >;
   const dbFilePath = (yield call(
      getBackupFilePath,
      i18n.t('Restore Transaction Datastore From')
   )) as SagaReturnType<typeof getBackupFilePath>;
   if (!dbFilePath) {
      return;
   }

   const {result: isEncrypted} = yield call(
      asyncSagaConstructor(
         qs.stringifyUrl({url: api.isEncrypted, query: {filePath: dbFilePath}}),
         backupTypes.IS_ENCRYPTED
      )
   );

   let password: string = '';
   if (isEncrypted) {
      password =
         ((yield call(
            getPassword,
            i18n.t('Confirm Restore File Password'),
            i18n.t('Enter Restore File Password')
         )) as SagaReturnType<typeof getPassword>) || '';
      if (!password) {
         return;
      }
   }

   let config = false;
   //find out if they want to restore config data
   if (isFeatureSupported(DiplomatFeature.RESTORE_CONFIG)) {
      const dialogResult: ICloseSubDialogAction<boolean> = yield call(openDialogWithResult, {
         id: DialogTypes.ConfirmDialog.id,
         data: {
            title: i18n.t('Configuration Settings Restore'),
            content: i18n.t(
               'Do you want to restore the configuration and user settings in addition to\nthe Transaction Datastore?'
            ),
            cancelLabel: i18n.t('No'),
         } as ConfirmDialogData,
      });
      config = !!dialogResult.payload?.data;
   }

   yield call(openRestoreDialog, dbFilePath, config, password);
}
